import styles from "./FacultyUnitInfo.module.scss";
import { Fragment } from "react";
import classNames from "classnames";
import { LinkWrapper } from "Explore/Components";

const FacultyUnitInfo = ({ unitInfo = {} }) => {
  return (
    <div className={styles["faculty-unit"]}>
      {Object.entries(unitInfo).map(([name, { id, explore_slug, subUnits }]) => (
        <div key={name} className={styles["faculty-unit--item"]}>
          {explore_slug || id ? (
            <LinkWrapper
              link={`/explore/unit/${explore_slug || id}`}
              component={
                <p
                  className={classNames(
                    styles["faculty-unit--item--name"],
                    styles["link"]
                  )}
                >
                  {name}
                </p>
              }
            />
          ) : (
            <p className={styles["faculty-unit--item--name"]}>{name}</p>
          )}
          <div>
            {subUnits.map((item) => (
              <Fragment key={item.id}>
                {!!(item.explore_slug || item.id) ? (
                  <LinkWrapper
                    key={item.id}
                    link={`/explore/unit/${item.explore_slug || item.id}`}
                    component={
                      <p
                        className={classNames(
                          styles["faculty-unit--item--sub-name"],
                          styles["link"]
                        )}
                      >
                        {item.name}
                      </p>
                    }
                  />
                ) : (
                  <p className={styles["faculty-unit--item--sub-name"]}>
                    {item.name}
                  </p>
                )}
              </Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FacultyUnitInfo;
